/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
import IconBase from './icon-base';
import Theme from '../../../themes';

const IconCircledRightArrow = ({
  className,
  fill = '#FFFFFF',
  stroke = Theme.colors.brand,
  height,
  hoverColor,
  width,
}) => (
  <IconBase className={className} viewBox="0 0 38 38" width={width} height={height} fill={fill} hoverColor={hoverColor}>
    <circle cx="19" cy="19" r="17.5" fill={fill} stroke={stroke} stroke-width="3" />
    <path
      d="M25.0394 19.6769L16.9115 27.428C16.5195 27.8019 15.8839 27.8019 15.492 27.428L14.544 26.524C14.1527 26.1508 14.1519 25.546 14.5423 25.1719L20.9838 19.0001L14.5423 12.8283C14.1519 12.4542 14.1527 11.8494 14.544 11.4762L15.492 10.5721C15.884 10.1983 16.5195 10.1983 16.9115 10.5721L25.0393 18.3232C25.4313 18.697 25.4313 19.3031 25.0394 19.6769Z"
      fill={stroke}
    />
  </IconBase>
);

export default IconCircledRightArrow;
